import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '@tmhcc-ng-lib/global-services';
import { Observable } from 'rxjs';
import { BaseContentService } from './base-content-service';
import { map } from 'rxjs/internal/operators/map';
import { catchError } from 'rxjs/internal/operators/catchError';
import { of } from 'rxjs/internal/observable/of';
import { ResetPassword } from './def/reset-password';

@Injectable({
  providedIn: 'root'
})
export class ResetPasswordService extends BaseContentService<ResetPassword> {
  constructor(
    protected http: HttpClient,
    protected configService: AppConfigService
  ) {
    super(http, configService, ResetPasswordService.staticResetPass);
  }

  get data$(): Observable<ResetPassword> {
    if (!this.loaded) {
      return this.getresetPasswordData();
    }

    return of(this.data);
  }

  getresetPasswordData(): Observable<ResetPassword> {
    const url = `${this.serviceBaseUrl}resetpassword`;
    return this.get<ResetPassword>(url).pipe(
      map(data => {
        this.data = this.resetPasswordMapper(data);
        this.loaded = true;
        return this.data;
      }),
      catchError(this.handleError)
    );
  }

  private resetPasswordMapper(data: ResetPassword): ResetPassword {
    if (!data) return;

    return data;
  }

  private static staticResetPass: ResetPassword = {
    pageName: 'resetpassword',
    forms: [
      {
        formName: '',
        isAdvanceSearch: false,
        fields: [
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: 1,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: true,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: 8,
              maxChar: 15,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: [
                {
                  key: '',
                  value: ''
                },
                {
                  key: '',
                  value: ''
                },
                {
                  key: '',
                  value: ''
                },
                {
                  key: '',
                  value: ''
                },
                {
                  key: '',
                  value: ''
                },
                {
                  key: '',
                  value: ''
                },
                {
                  key: '',
                  value: ''
                }
              ]
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: 2,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: true,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: [
                {
                  key: '',
                  value: ''
                },
                {
                  key: '',
                  value: ''
                }
              ]
            },
            config: null
          }
        ]
      }
    ],
    data: [
      {
        heading: '',
        title: '',
        description: '',
        text: '',
        image: null,
        displayItems: [
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          }
        ]
      }
    ],
    messages: [
      {
        heading: '',
        description: '',
        image: null,
        displayItems: [
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          }
        ]
      }
    ]
  };

  resetPasswordModal() {
    return {
      data: '',
      modalSetting: {
        title: '',
        hideHeader: false,
        hideFooter: true,
        hideHeaderX: false, // header X button;
        hideSave: true,
        closeOnOutsideClick: true
      }
    };
  }
}
